import { render, staticRenderFns } from "./AegPolicyTransactionsList.vue?vue&type=template&id=f64a29c4"
import script from "./AegPolicyTransactionsList.vue?vue&type=script&lang=js"
export * from "./AegPolicyTransactionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports